import '../../common/bn-load-more-button';
import '../../common/bn-loading';
import './work-order-location';
import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

class WorkOrderLocations extends LitEntity {
  constructor() {
    super();
    this.locations = [];
  }

  static get properties() {
    return {
      locations: { type: Array },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .actions {
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
      }
      .actions > * {
        white-space: nowrap;
        margin: .5em 0 0 .5em;
      }
      .no-data {
        text-align: center;
        padding: 1em;
      }
    `];
  }

  render() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }
    if (!this.locations.length) {
      return html`
        <p class="no-data">There are no Work Order Locations to display.</p>
      `;
    }
    return html`
      <div class="locations">
        ${this.locations.map((location) => html`
          <work-order-location .href="${this.getHref('self', location)}" @reload="${this._reload}"></work-order-location>
        `)}
      </div>
      <div class="actions">
        <bn-load-more-button .href="${this.href}"></bn-load-more-button>
      </div>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.locations = this.entity?.getSubEntitiesByClass('work-order-location') || [];
  }

  _reload() {
    entityStore.invalidateHref(this.href);
  }
}

customElements.define('work-order-locations', WorkOrderLocations);
